import { render, staticRenderFns } from "./MultiSelectorEvento.vue?vue&type=template&id=526c7642&scoped=true"
import script from "./MultiSelectorEvento.vue?vue&type=script&lang=js"
export * from "./MultiSelectorEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c7642",
  null
  
)

export default component.exports